import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { RoleService } from '@lyceo/shared/permissions/data-access';

export function noRoleGuard(
  redirectUrl: string[],
  allowedRoles: string[],
): CanActivateFn {
  return () => {
    const router: Router = inject(Router);
    const roleService: RoleService = inject(RoleService);

    return roleService.hasRequiredRole(allowedRoles).pipe(
      map((hasRole: boolean) => {
        if (hasRole) {
          return router.createUrlTree(redirectUrl);
        }
        return true;
      }),
    );
  };
}
